export default "__VITE_ASSET__iWLvbG_g__"